import React, { useEffect } from "react";
import { any } from "prop-types";

import { PopupButton } from "@typeform/embed-react";

import CoverPorfolio from "../../components/cover-portfolio";

import {
	LargeText,
	SmallHeading,
	SmallTitle,
	MediumTitle,
} from "../../ui-components/texts";

// import PeopleOfMasamune from "../../components/people-of-masamune";
import { DetailsProject } from "../../components/portfolio-components";
import {
	Column,
	Container,
	ContainerBlock,
} from "../../ui-components/columns/components";
import { FullWidthVideo } from "../../ui-components/videos";
import PeopleOfMasamune from "../../components/people-of-masamune";

// images
import imageCover from "../../media/images/portfolio-images/livemefive/image-cover.jpg";
import { ImageLeftWithText } from "./components-content";
import { useTranslate } from "../../contexts/translate";

const Livemefive = ({
	setNextPageHref = () => {},
	setNextPageName = () => {},
}) => {
	const { translations } = useTranslate();

	useEffect(() => {
		setNextPageHref("/projects/micidial");
		setNextPageName("Micidial");
		document.title = "LiveMeFive - Cutting Edge Digital Creative Studio";
	}, []);

	const peoples = [
		{
			fullname: "Andrea Anfuso",
			image: require("../../media/team-images/Andrea Anfuso.jpg").default,
			role: translations === null ? "" : translations.about.peoples[0].role,
			description:
				translations === null ? "" : translations.about.peoples[0].description,
		},
		{
			fullname: "Samuele Olindo",
			image: require("../../media/team-images/Samuele Olindo.jpg").default,
			role: translations === null ? "" : translations.about.peoples[18].role,
			description:
				translations === null ? "" : translations.about.peoples[18].description,
		},
	];

	return (
		<div className="project-page project-page-ohoskin">
			<CoverPorfolio
				background="#fff"
				title="LiveMeFive"
				text={translations && translations.livemefive.intro}
				image={imageCover}
			/>

			<DetailsProject
				client={"Livemefive"}
				services={["Coding"]}
				timeframe={"2023"}
				introduction={
					<>
						<LargeText>
							{translations && translations.livemefive.descriptions[0]}
						</LargeText>
						<LargeText>
							{translations && translations.livemefive.descriptions[1]}
						</LargeText>
					</>
				}
			/>

			<section className="theme-light" style={{ background: "#fff" }}>
				<Container>
					<div className="wrapper fluid  pb-0">
						<Column>
							<MediumTitle>
								{translations && translations.livemefive.sections[0].title}
							</MediumTitle>
							<LargeText>
								{translations && translations.livemefive.sections[0].text}
							</LargeText>
							<LargeText>
								{translations && translations.livemefive.sections[0].text1}
							</LargeText>
						</Column>
					</div>
				</Container>

				<Container className="theme-dark" style={{ background: "#FB322D" }}>
					<div className="wrapper fluid pb-5">
						<Column>
							<video
								width="100%"
								src={
									require("../../media/images/portfolio-images/livemefive/1.mp4")
										.default
								}
								loop={true}
								muted={true}
								autoPlay={true}
								controls={false}
								playsInline={true}
							></video>
						</Column>
						<Column>
							<video
								width="100%"
								src={
									require("../../media/images/portfolio-images/livemefive/2.mp4")
										.default
								}
								loop={true}
								muted={true}
								autoPlay={true}
								controls={false}
								playsInline={true}
							></video>
						</Column>
						<Column>
							<video
								width="100%"
								src={
									require("../../media/images/portfolio-images/livemefive/3.mp4")
										.default
								}
								loop={true}
								muted={true}
								autoPlay={true}
								controls={false}
								playsInline={true}
							></video>
						</Column>
					</div>
				</Container>
			</section>

			<ImageLeftWithText
				className="theme-light"
				color="#fff"
				//title={translations && translations.ohoskin.sections[0].title}
				texts={[translations && translations.livemefive.sections[1].text]}
				image={
					require("../../media/images/portfolio-images/livemefive/image-sx.png")
						.default
				}
			/>

			<PeopleOfMasamune peoples={peoples} />
					<div className="cta-single-project">
				<div className="cta-single-project-inner">
					<p>{translations && translations.ctasingleproject.text}</p>
					<button
						className="leadconnector-button"
						onClick={() => {
							const overlay = document.createElement("div");
							overlay.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													background-color: rgba(0, 0, 0, 0.7);
													backdrop-filter: blur(5px);
													z-index: 9998;
												`;

							const modal = document.createElement("div");
							modal.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													z-index: 9999;
												`;

							const closeBtn = document.createElement("button");
							closeBtn.innerHTML = "✕";
							closeBtn.style.cssText = `
													position: fixed;
													top: 30px;
													right: 30px;
													width: 50px;
													height: 50px;
													border: none;
													background-color: rgba(255, 255, 255, 0.2);
													color: white;
													border-radius: 50%;
													cursor: pointer;
													font-size: 28px;
													z-index: 10000;
													transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
													backdrop-filter: blur(10px);
													border: 1px solid rgba(255, 255, 255, 0.3);
													display: flex;
													align-items: center;
													justify-content: center;
												`;
							closeBtn.onmouseover = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.3)";
								closeBtn.style.transform = "scale(1.15) rotate(90deg)";
								closeBtn.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.3)";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.5)";
							};
							closeBtn.onmouseout = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
								closeBtn.style.transform = "scale(1) rotate(0deg)";
								closeBtn.style.boxShadow = "none";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.3)";
							};
							closeBtn.onclick = () => {
								overlay.style.opacity = "0";
								modal.style.opacity = "0";
								overlay.style.transition = "opacity 0.4s ease-out";
								modal.style.transition = "opacity 0.4s ease-out";
								setTimeout(() => {
									document.body.removeChild(overlay);
									document.body.removeChild(modal);
								}, 400);
							};

							const iframe = document.createElement("iframe");
							iframe.src =
								"https://api.leadconnectorhq.com/widget/survey/fXRdOm9p3aM4iNGpHfOa?notrack=true";
							iframe.style.cssText = `
													width: 100%;
													height: 100%;
													border: none;
												`;
							iframe.allowFullscreen = true;

							modal.appendChild(iframe);
							modal.appendChild(closeBtn);
							document.body.appendChild(overlay);
							document.body.appendChild(modal);

							overlay.onclick = () => {
								document.body.removeChild(overlay);
								document.body.removeChild(modal);
							};
						}}
					>
						{translations && translations.ctasingleproject.button}
					</button>
				</div>
			</div>
		</div>
	);
};

Livemefive.propTypes = {
	setNextPageHref: any,
	setNextPageName: any,
};

export default Livemefive;
